import type { ReactNode } from "react";
import { BotonVolver } from "./BotonVolver";
import { MigasDePan, type MigaDePan } from "./MigasDePan";

export function EncabezadoPagina({
  titulo,
  descripcion,
  acciones,
  volver,
  migas,
  pestanas,
}: {
  titulo: string;
  descripcion?: string;
  acciones?: ReactNode;
  /** Pantallas secundarias/fichas/editores: botón "Volver" global (ver BotonVolver.tsx). */
  volver?: { rutaPadre: string; etiqueta?: string };
  /** Breadcrumbs — omitir en pantallas principales, donde serían ruido. */
  migas?: MigaDePan[];
  /** Navegación entre vistas relacionadas del mismo recurso (ej. Visual/Tabla/Kanban). */
  pestanas?: ReactNode;
}) {
  return (
    <div className="mb-6">
      {volver && <BotonVolver rutaPadre={volver.rutaPadre} etiqueta={volver.etiqueta} className="mb-2" />}
      {migas && <MigasDePan items={migas} />}
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold text-texto">{titulo}</h1>
          {descripcion && <p className="mt-1 text-sm text-texto-secundario">{descripcion}</p>}
        </div>
        {acciones && <div className="flex flex-wrap gap-2">{acciones}</div>}
      </div>
      {pestanas && <div className="mt-3">{pestanas}</div>}
    </div>
  );
}
